/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_footer__faq_title = /** @type {(inputs: {}) => string} */ () => {
	return `Häufig gestellte Fragen`
};

const en_footer__faq_title = /** @type {(inputs: {}) => string} */ () => {
	return `Frequently asked questions`
};

const es_footer__faq_title = /** @type {(inputs: {}) => string} */ () => {
	return `Preguntas más frecuentes`
};

const fr_footer__faq_title = /** @type {(inputs: {}) => string} */ () => {
	return `Questions fréquentes`
};

const it_footer__faq_title = /** @type {(inputs: {}) => string} */ () => {
	return `Domande frequenti`
};

const nl_footer__faq_title = /** @type {(inputs: {}) => string} */ () => {
	return `Veelgestelde vragen`
};

const pt_footer__faq_title = /** @type {(inputs: {}) => string} */ () => {
	return `Perguntas mais frequentes`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const footer__faq_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.footer__faq_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("footer__faq_title", locale)
	if (locale === "de") return de_footer__faq_title(inputs)
	if (locale === "en") return en_footer__faq_title(inputs)
	if (locale === "es") return es_footer__faq_title(inputs)
	if (locale === "fr") return fr_footer__faq_title(inputs)
	if (locale === "it") return it_footer__faq_title(inputs)
	if (locale === "nl") return nl_footer__faq_title(inputs)
	return pt_footer__faq_title(inputs)
};